import styled from "styled-components";

export const StyledContainer: any = styled.div`
  padding: 20px;
  outline: none;
  text-align: center;
  border-color: ${(props: any) => (props.valid ? "#1abc9c" : props.invalid ? "#f1556c" : "default")};
  color: ${(props: any) => (props.invalid ? "#f1556c" : "default")};
`;

export const StyledContent: any = styled.div`
  display: ${(props: any) => (props.visible ? "block" : "none")};
`;
